import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import * as moment from 'moment';

import { UserService } from '../../../../../auth/user.service';
import { TruckviewsDashboardService } from '../truckviews-dashboard.service';
import { DevicesDashboardService } from '../../../devices/devices-dashboard.service';
import { NotificationMessageService } from '../../../../../shared/notification-message/notification-message.service';

@Component({
	selector: 'app-truckview-select-criteria',
	templateUrl: './truckview-select-criteria.component.html',
	styleUrls: ['./truckview-select-criteria.component.css']
})
export class TruckviewSelectCriteriaComponent implements OnInit {
	
	@Input() truckviewID: number;
	@Input() currentUser: any;
	@Input() customerId: number = 0;
	@Input() siteId: number = 0;
	@Input() activePage: string = null;
	@Input() activeTab: string = null;
	@Input() activeSubTab: string = null;
	@Input() multipleOptions: boolean = false;
	@Input() isACTuser: boolean = false;
	@Input() siteInfo: any = {};
	@Input() showElementsFlags: {
		addNoteEnabled: boolean,
		pageHasFilterByDate: boolean,
		pageHasTruckviewTags: boolean,
		hasResetPLC: boolean,
		pageHasManageBtn: boolean,
		pageHasTimesInfo: boolean,
	} = {
		addNoteEnabled: false,
		pageHasFilterByDate: false,
		pageHasTruckviewTags: false,
		hasResetPLC: false,
		pageHasManageBtn: true,
		pageHasTimesInfo: true,
	};

	date: {
		fromDate: any,
		toDate: any
	} = {
		fromDate: new Date(),
		toDate: new Date()
	};
	truckviews: any[] = [{}];
	device: any;
	siteTags: any[] = [];
	siteGroups: any[] = [];
	deviceTags: any = {};
	hasTruckviews: boolean = true;

	firstAcceptedDay	 = new Date(1*24*60*60*1000);

	@Output() onDeviceChanged = new EventEmitter<any[]>(true);
	@Output() onDateChanged = new EventEmitter<{fromDate: any, toDate: any}>(true);
	@Output() onResetPLC = new EventEmitter<boolean>(true);
	@Output() updateHasTruckviews = new EventEmitter<boolean>(true);
	@Output() updateAlertSettings = new EventEmitter<any>(true);

	constructor(
		public userService: UserService,
		private route: ActivatedRoute,
		private router: Router,
		private location: Location,
		private truckviewsDashboard: TruckviewsDashboardService,
		private devicesDashboardService: DevicesDashboardService,
		private notificationMessage: NotificationMessageService,
		private devicesDashboard: DevicesDashboardService
	) { }

	ngOnInit() {
		// get truckviews
		if(this.activePage == 'settings') {
			this.getTruckviews();
		} else {

			this.route.params.subscribe(params => {
				this.truckviewID = +(params['truckviewID']) || 0;
				this.getTruckviews();
			});
		}
		
		this.setDates(this.activePage, true);
		this.datesChanged();
	}

	getTruckviews() {
		this.truckviewsDashboard.getTruckviews({customerid : this.customerId, siteid : this.siteId, getTags: true, getGroups: this.siteInfo.act_first_enabled}).subscribe(
			(response: any) => {
				response = {"list":[{"id":26438,"serialnumber":"321111800565","model":"","versionno":0,"modificationdate":"2018-11-03T17:30:05.677Z","createdat":"2018-11-03T00:00:00.000Z","customerid":40,"siteid":100,"ispa":false,"dealerid":24,"userid":"0","isdeleted":false,"ownerchangedate":"2018-11-03T17:30:05.677Z","version":"","bfd_versionno":0,"bfd_id":"0","ahrcapacity":1000,"bfd_serialnumber":"","modelnumber":"","nominalvoltage":36,"numberofcells":18,"equalizestartwindow":"","equalizeclosewindow":"","finishstartwindow":"","finishclosewindow":"","eqstart":0,"eqend":0,"finishstart":0,"finishend":0,"lastconnecttime":1550690082000,"actviewdisablereq":false,"workingdays":null,"eqdaysmask":[0,6],"fidaysmask":[0,1,2,3,4,5,6],"fistartwindow":"00:00","eqstartwindow":"00:00","eqtimer":"24:00","fitimer":"24:00","batteryid":"7595EH/F20","batteryhightemperature":54.4,"firmwareversion":2.63,"eventscount":416,"actviewconnectfrequency":300,"enabledaylightsaving":true,"zoneid":11,"setup":170,"battviewversion":2,"memorysignature":21,"lastchangetime":"2019-02-05T18:03:35.000Z","internalchargerid":0,"lastchangeuserid":963,"installationdate":"2019-01-08T23:27:24.000Z","warrantedahr":1250000,"cvmaxduration":"04:00","eqclosewindow":86400,"ficlosewindow":86399,"fiduration":"03:00","eqduration":"04:00","desulfation":"12:00","tempfa":3984,"tempfb":3936,"tempfc":0,"voltagecala":2.93670344352722,"voltagecalb":24.789421081543,"ntccala":-1.39915204048157,"ntccalb":8.47429084777832,"currentcala":-1.39915204048157,"currentcalb":8.47429084777832,"intercelltemperaturecala":52302.140625,"intercelltemperaturecalb":-41598.6015625,"intercellcoefficient":0.00400000018998981,"chargetoidletimer":300,"chargetoinusetimer":30,"inusetochargetimer":60,"inusetoidletimer":600,"idletochargetimer":10,"idletoinusetimer":10,"electrolytehlt":120,"electrolytelht":120,"tricklevoltage":2,"cvtargetvoltage":2.4,"tricklecurrentrate":5,"ccrate":25,"cvendcurrentrate":12,"cvcurrentstep":0,"fitargetvoltage":2.6,"ficurrentrate":5,"eqvoltage":2.65,"eqcurrentrate":4,"autologtime":15,"mobileport":50000,"actviewport":9309,"currentidletocharge":110,"currentidletoinuse":-110,"currentchargetoidle":90,"currentchargetoinuse":-110,"currentinusetocharge":110,"currentinusetoidle":-90,"softappassword":"actDirmank","actviewip":"52.11.167.54","hwversion":"BE","actaccessssid":"actAccess24","mobileaccessssid":"act24mobile","actaccessssidpassword":"hala3ami102","mobileaccessssidpassword":"shlonak5al","actviewenabled":true,"softapenable":false,"enableelectrolyesensing":true,"enablehalleffectsensing":true,"enableexttempsensing":true,"batterytype":0,"batterytemperaturecompesnation":6,"fidv":5,"fidt":59,"eventdetectvoltagepercentage":2,"eventdetectcurrentrangepercentage":80,"eventdetecttimerangepercentage":67,"enableplc":true,"temperatureformat":1,"chargertype":2,"signature":42662,"seq":168789,"rtrecordscount":0,"inuseahr":18328,"inusekwhr":640,"chargeahr":19325,"chargekwhr":819,"inuseseconds":613135,"chargeseconds":498349,"idleseconds":1410781,"leftoverinuseas":515,"leftoverinusews":2689388,"leftoverchargeas":342,"leftoverchargews":2173452,"debugcount":163,"lostrtc":0,"endsignature":74,"oemid":0,"lastfirmwareversion0":2.99,"lastfirmwareversion1":0,"manualuploadeventscount":417,"trtemperature":10,"foldtemperature":51.7,"cooldowntemperature":46.1,"foldtemperaturecompensation":0,"studyid":"0","currentclampcala":4.60311,"currentclampcalb":-9427.17,"currentclamp2cala":4.50961,"currentclamp2calb":-9217.27,"servicedealerid":12,"batterymodel":"18-F125-17","batterysn":"7595EH","batterymanfacturingdate":"2018-05-27T00:00:00.000Z","battviewwarrantydate":"2018-11-03T17:30:05.677Z","originalactviewconnectfrequency":0,"autoconnectrequesttime":"1970-01-01T00:00:00.000Z","replacmentpart":false,"add_inuseahr":"0","add_inusekwhr":"0","add_chargeahr":"0","add_chargekwhr":"0","add_inuseseconds":"0","add_chargeseconds":"0","add_idleseconds":"0","studyname":"","truckid":"F20","temperaturecontrol":0,"lastuploadtime":"2019-02-20T18:54:04.678Z","lasteventtime":"2019-02-20T11:58:49.000Z","mainsenseerrorcode":2,"blockedeqdays":0,"blockedfidays":0,"deviceactviewenable":false,"plc_event_time":"2019-02-20T17:58:49.000Z","last_charge_cycle_time":"2019-02-20T17:04:23.000Z","hide_plc_fault_date":"1970-01-01T00:00:00.000Z","hastemperaturesensorfault":false,"time_gap":502,"ip_address":"174.234.0.221","halleffectscale":1,"disableintercell":false,"wifi_local_ip":"192.168.30.127","wifi_gateway":"192.168.30.1","wifi_mac_address":"60:113:191:67:184:28","wifi_at_version":"ACT-1.35","wifi_last_refresh_time":"2019-02-20T14:24:36.214Z","last_demo_synch_time":"1970-01-01T00:00:00.000Z","esp32_wifi_version":1.23,"socanreset":true,"commissiondate":"2018-11-03T17:30:05.677Z","assignedtoproductionlinedate":"2019-01-08T23:27:24.972Z","shippingdate":"2019-01-08T00:00:00.000Z","warrantyperiod":1,"actfirstgroupid":null,"manufacturingdateview":"2018-05-27T00:00:00.000Z","manufacturingdatesameasinstallation":false,"fischedulingmode":1}],"count":1,"tags":{"siteTags":{"178":{"id":178,"tagname":"Calibration","customerid":"40","siteid":"100","tagcreatetime":"2017-04-24T14:18:32.056Z","isdeleted":false,"ownerid":182,"sharingoption":"group"},"402":{"id":402,"tagname":"BATTERY-REPAIR","customerid":"40","siteid":"100","tagcreatetime":"2017-07-16T00:56:08.112Z","isdeleted":false,"ownerid":182,"sharingoption":"public"},"544":{"id":544,"tagname":"offline","customerid":"40","siteid":"100","tagcreatetime":"2017-09-25T20:53:46.993Z","isdeleted":false,"ownerid":182,"sharingoption":"group"},"626":{"id":626,"tagname":"Temp-Testing","customerid":"40","siteid":"100","tagcreatetime":"2017-10-03T14:22:07.064Z","isdeleted":false,"ownerid":182,"sharingoption":"group"},"1193":{"id":1193,"tagname":"Temp-test-thiker","customerid":"40","siteid":"100","tagcreatetime":"2018-03-27T19:34:11.031Z","isdeleted":false,"ownerid":18,"sharingoption":"group"},"1197":{"id":1197,"tagname":"temp-test-carlos","customerid":"40","siteid":"100","tagcreatetime":"2018-04-03T20:50:35.614Z","isdeleted":false,"ownerid":182,"sharingoption":"group"},"1199":{"id":1199,"tagname":"temp-test-<130","customerid":"40","siteid":"100","tagcreatetime":"2018-04-04T17:55:51.431Z","isdeleted":false,"ownerid":182,"sharingoption":"group"},"1206":{"id":1206,"tagname":"no-temp-change","customerid":"40","siteid":"100","tagcreatetime":"2018-04-06T14:14:40.867Z","isdeleted":false,"ownerid":182,"sharingoption":"group"},"1463":{"id":1463,"tagname":"NOT-INSTALLED PROJECTED 1/21","customerid":"40","siteid":"100","tagcreatetime":"2019-01-15T18:55:38.608Z","isdeleted":false,"ownerid":44,"sharingoption":"public"},"1467":{"id":1467,"tagname":"OUT-OF-RANGE","customerid":"40","siteid":"100","tagcreatetime":"2019-01-22T18:16:24.336Z","isdeleted":false,"ownerid":963,"sharingoption":"public"},"1468":{"id":1468,"tagname":"Not On Site","customerid":"40","siteid":"100","tagcreatetime":"2019-01-23T19:01:45.274Z","isdeleted":false,"ownerid":963,"sharingoption":"public"},"1469":{"id":1469,"tagname":"RETURNED TO ACT DAMAGED","customerid":"40","siteid":"100","tagcreatetime":"2019-01-28T16:48:37.346Z","isdeleted":false,"ownerid":44,"sharingoption":"public"}},"deviceTags":{"10745":["1468","544"],"10758":["1199"],"10759":[],"10764":["1468","544"],"10775":["1468"],"10780":[],"10797":[],"10798":[],"10801":[],"10807":[],"10812":[],"10841":[],"10850":[],"10861":[],"10865":[],"10868":[],"11590":[],"11627":["1197"],"13582":["1468"],"13671":[],"13679":[],"13714":[],"13722":["1468"],"13728":[],"13731":["178"],"15233":["544"],"16161":["1199"],"16296":[],"22988":[],"23122":[],"23125":[],"23130":[],"23232":[],"23233":[],"23234":[],"23235":[],"23240":[],"23245":[],"23255":[],"23257":[],"23260":[],"23376":["544"],"23381":["1199"],"23387":[],"23388":["1197"],"23395":[],"23404":[],"24193":[],"24322":[],"24394":[],"26259":["1197"],"26394":["1193"],"26398":[],"26399":[],"26403":[],"26404":[],"26408":[],"26415":[],"26426":[],"26438":[],"26442":[],"26445":[],"26447":["1463"],"26681":[],"26700":[],"26721":[],"26796":[],"26810":[],"26819":[],"26855":[],"26858":[],"26860":[],"26873":[],"26876":[],"26879":[],"26906":["1193"],"26926":[],"26969":[],"26979":[],"27003":[],"27007":[],"27011":[],"27018":["1197"],"27026":[],"27031":["1199"],"29054":["544"]}},"alertSettings":{"id":34,"override_temperature_limit":true,"temperature_limit":54.4,"temperature_send_frequency":"weekly","ebu_alert_send_frequency":"none","conventional_ebu_limit":1,"opportunity_ebu_limit":1.25,"fast_ebu_limit":1.6,"water_level_low_days":2,"subscribed_users":["89","245"],"subscribed_act_users":["47","44","26","24","177","352","804","35","954"],"water_level_send_frequency":"weekly","missed_eq_send_frequency":"none","missed_fi_send_frequency":"weekly","dealerid":"0","siteid":"100","missed_connection_alert":{"0":[{"start":0,"end":86400}],"1":[{"start":0,"end":86400}],"2":[{"start":0,"end":86400}],"3":[{"start":0,"end":86400}],"4":[{"start":0,"end":86400}],"5":[{"start":0,"end":86400}],"6":[{"start":0,"end":86400}]},"missed_plugged_in_frequency":"weekly","missed_plugged_in_timespan":5,"site_disconnection_frequency":"daily","site_disconnection_timespan":24,"deep_use_frequency":"weekly","deep_use_limit":1.7,"deep_discharge_frequency":"weekly","deep_discharge_limit":2,"charger_alert_frequency":"none","pm_faults_frequency":"daily","cycle_abnormal_stop_frequency":"none","charger_alert_type":"latching","cycle_abnormal_faults":["pm-fauts"],"charger_disconnection_frequency":"daily","charger_disconnection_timespan":24,"battview_disconnection_frequency":"weekly","battview_disconnection_timespan":120,"sulfated_battery_frequency":"weekly","missed_weekly_eq_send_frequency":"weekly","high_temperature_limit_days":2,"potential_weak_cells_limit_days":2,"deep_discharge_limit_days":2,"view_truck_id":true,"expected_fast_chargers_cycles":2,"expected_conventional_chargers_cycles":1,"expected_opportunity_chargers_cycles":2,"site_weekly_working_days":5,"charger_utilization_alert_frequency":"weekly","enable_no_alert":null,"missed_plugin_cycles_alert_frequency":"none","expected_plugin_charge_cycles":1,"weekly_plugin_working_days":5,"idle_times_limit":60,"idle_times_frequency":"none"},"groups":[]};
				this.hasTruckviews = (response.list.length > 0);
				this.updateHasTruckviews.emit(this.hasTruckviews);

				// sort response by truckid then serialnumber
				var sortedList =  _.chain(response.list)
									.sortBy('serialnumber')
									.sortBy('truckid')
									.value();

				this.truckviews	= sortedList;
				this.siteTags	= response.tags.siteTags;
				this.siteGroups	= response.groups || [];
				
				this.updateAlertSettings.emit(response.alertSettings);

				let deviceTags = {};

				this.truckviews.forEach((item) => {
					deviceTags[item.id] = [];
					response.tags.deviceTags[item.id].forEach((tagItem) => {
						deviceTags[item.id].push(this.siteTags[tagItem]);
					});
					item.appearanceName = item.truckid + ' (' + item.serialnumber + ') ';
				});
				this.deviceTags	= deviceTags;

				if (this.truckviewID > 0) {
					for(var i = 0; i < response.list.length; i++){
						if(response.list[i].id == this.truckviewID) {
							this.device = response.list[i];
							this.truckviewChanged(false);
							break;
						}
					}
				}
			}
		);
	}

	updateTags(event) {
		if (event.type == 'add') {
			this.deviceTags[this.device.id].push(event.tag);
			if(!this.siteTags[event.tag.id]) {
				this.siteTags[event.tag.id] = event.tag;
			}
		} else {
			// remove
			let removedTagId = event.tag.id;
			let deviceTag = [];
			this.deviceTags[this.device.id].forEach((tag) => {
				if(tag.id != removedTagId) {
					deviceTag.push(tag);
				}
			})
			this.deviceTags[this.device.id] = deviceTag;
		}
	}

	truckviewChanged(changeUrl = true){
		if(changeUrl) {
			let url: any[] = [this.activePage];
			let queryParams = {};

			switch(this.activePage) {
				case 'analytics':
					url.push(this.activeTab, this.device.id || 0);
					if(this.activeSubTab) {
						url.push(this.activeSubTab);
					}
				break;
				case 'settings':
					queryParams = {'truckviewsIDs': this.device.id || 0};
				break;
				default:
					url.push(this.device.id || 0);
				break;
			}
			
			this.location.go(
				this.router.createUrlTree(
					url,
					{'relativeTo': this.route.parent, 'queryParams': queryParams}
				).toString()
			);
		}

		this.onDeviceChanged.emit([this.device, this.date]);
	}
	datesChanged() {
		this.onDateChanged.emit(this.date);
	}
	resetPLC() {
		this.devicesDashboardService.resetPLCFault('truckview', this.device.id).subscribe(
			(msg:string) => {
				this.showElementsFlags.hasResetPLC = false;
				this.notificationMessage.setMessage('globalSuccessMsg', 'success');
				this.onResetPLC.emit(true);
		});
	}
	setDates(tab, isInit = false) {
		if(tab == 'connectivity-track') {
			this.date.fromDate	= new Date(moment().utc().subtract(1, 'days').startOf('day').unix() * 1000);
			this.date.toDate	= new Date(moment().utc().startOf('day').unix() * 1000);
		} else if(tab == 'debug-records') {
			
			this.date.fromDate	= new Date(moment().utc().subtract(6, 'days').startOf('day').unix() * 1000);
			this.date.toDate	= new Date(moment().utc().startOf('day').unix() * 1000);
		} else {

			if(isInit) {
				this.date.fromDate.setDate(this.date.fromDate.getDate() - 30);
				this.date.toDate	= new Date();
			}
		}
	}	
	addGroup(group) {
		this.devicesDashboard.assignDeviceToGroup(this.siteInfo.id, group.id, 'truckview', this.device.id).subscribe((res) => {
			this.notificationMessage.setMessage(res, 'success', 10000, true);
		});
	}
}